import * as guestConstant from './constants'

export const guestReportNvkdRequest = (formData) => {
  return {
    type: guestConstant.GUEST_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const guestReportNvkdSuccess = (data) => {
  return {
    type: guestConstant.GUEST_REPORT_NVKD_SUCCESS,
    data
  }
}

export const guestReportNvkdError = (error) => {
  return {
    type: guestConstant.GUEST_REPORT_NVKD_ERROR,
    error
  }
}
export const guestReportKhRequest = (formData) => {
  return {
    type: guestConstant.GUEST_REPORT_KH_REQUESTING,
    formData
  }
}

export const guestReportKhSuccess = (data) => {
  return {
    type: guestConstant.GUEST_REPORT_KH_SUCCESS,
    data
  }
}

export const guestReportKhError = (error) => {
  return {
    type: guestConstant.GUEST_REPORT_KH_ERROR,
    error
  }
}
export const guestReportListRequest = (formData) => {
  return {
    type: guestConstant.GUEST_REPORT_LIST_REQUESTING,
    formData
  }
}

export const guestReportListSuccess = (data) => {
  return {
    type: guestConstant.GUEST_REPORT_LIST_SUCCESS,
    data
  }
}

export const guestReportListError = (error) => {
  return {
    type: guestConstant.GUEST_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: guestConstant.GUEST_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: guestConstant.GUEST_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: guestConstant.GUEST_REPORT_EXPORT_XLS_ERROR,
    error
  }
}

export const guestReportNhomKhRequest = (formData, callback) => {
  return {
    type: guestConstant.GUEST_REPORT_NHOMKH_REQUESTING,
    payload: formData,
    callback
  }
}

export const guestReportNhomKhSuccess = (data) => {
  return {
    type: guestConstant.GUEST_REPORT_NHOMKH_SUCCESS,
    data
  }
}

export const guestReportNhomKhError = (error) => {
  return {
    type: guestConstant.GUEST_REPORT_NHOMKH_ERROR,
    error
  }
}

export const guestReportKhByNhomRequest = (formData, callback) => {
  return {
    type: guestConstant.GUEST_REPORT_KH_BY_NHOM_REQUESTING,
    payload: formData,
    callback
  }
}

export const guestReportKhByNhomSuccess = (data) => {
  return {
    type: guestConstant.GUEST_REPORT_KH_BY_NHOM_SUCCESS,
    data
  }
}

export const guestReportKhByNhomError = (error) => {
  return {
    type: guestConstant.GUEST_REPORT_KH_BY_NHOM_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/GuestReport/actions.js